import type { PaginationResponse } from "@rpcbase/api"

import type { PaginationCursorCodecOptions } from "./cursor"
import { encodePaginationCursor } from "./cursor"
import type { CompiledMongoPagination } from "./compileMongoPagination"


export type MaterializePaginationOptions = {
  cursor: PaginationCursorCodecOptions;
}

export const materializeMongoPagination = <TNode>(
  compiled: CompiledMongoPagination,
  fetchedNodes: TNode[],
  options: MaterializePaginationOptions,
): PaginationResponse<TNode> => {
  const limit = compiled.spec.limit
  const hasMore = fetchedNodes.length > limit

  const trimmed = fetchedNodes.slice(0, limit)
  const nodes = compiled.spec.direction === "prev" ? trimmed.reverse() : trimmed

  const hasPrevPage = compiled.spec.direction === "next" ? Boolean(compiled.spec.cursor) : hasMore
  const hasNextPage = compiled.spec.direction === "next" ? hasMore : Boolean(compiled.spec.cursor)

  const pageInfo: PaginationResponse<TNode>["pageInfo"] = {
    hasNextPage,
    hasPrevPage,
  }

  if (nodes.length === 0) {
    return { nodes, pageInfo }
  }

  if (hasPrevPage) {
    pageInfo.prevCursor = encodePaginationCursor(compiled.spec, nodes[0], options.cursor)
  }

  if (hasNextPage) {
    pageInfo.nextCursor = encodePaginationCursor(compiled.spec, nodes[nodes.length - 1], options.cursor)
  }

  return { nodes, pageInfo }
}
